/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Screen_OnInputs */

const en_cook_screen_on = /** @type {(inputs: Cook_Screen_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screen on`)
};

const de_cook_screen_on = /** @type {(inputs: Cook_Screen_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildschirm an`)
};

/**
* | output |
* | --- |
* | "Screen on" |
*
* @param {Cook_Screen_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_screen_on = /** @type {((inputs?: Cook_Screen_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Screen_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_screen_on(inputs)
	return en_cook_screen_on(inputs)
});